import { checkCompatibility } from '@ipfabric/utils/siteSeparation';
import { hasRegExpMatchingGroups } from 'utils/regexp/hasRegExpMatchingGroups';
import { isValidRegExp } from 'utils/validation/isValidRegExp';

export type RegexRuleValidationResult = {
  regex?: string;
  siteName?: string;
};

export type SiteSeparationFormRule = {
  regex: string;
  // `null` means "use generated site name from the first capturing group".
  siteName: string | null;
};

const msgRegexErrors = {
  missingRegex: 'Regular Expression is mandatory.',
  invalidRegex: 'This Regular Expression is not valid.',
  missingSiteName:
    'Site Name is mandatory when Regular Expression does not contain a matching group.',
  missingSiteNameWithGroup: 'Site Name is mandatory or use default',
};

export const validateRegexRule = (
  rule: SiteSeparationFormRule,
): RegexRuleValidationResult => {
  const siteNameMissing = rule.siteName === null || rule.siteName === '';
  const result: RegexRuleValidationResult = {};
  if (rule.regex === '') {
    result.regex = msgRegexErrors.missingRegex;
  } else if (!isValidRegExp(rule.regex)) {
    result.regex = msgRegexErrors.invalidRegex;
  } else if (!hasRegExpMatchingGroups(rule.regex) && siteNameMissing) {
    result.siteName = msgRegexErrors.missingSiteName;
  } else if (hasRegExpMatchingGroups(rule.regex) && rule.siteName === '') {
    result.siteName = msgRegexErrors.missingSiteNameWithGroup;
  } else {
    const compat = checkCompatibility(rule.regex, rule.siteName);
    if (compat !== null) {
      result.siteName = compat;
    }
  }
  return result;
};
